<template>
  <tr v-if="trailer">
    <td class="align-middle d-none d-md-table-cell">
      <router-link :to="'/trailer/' + quoteItem.assetId" class="opacity">
        <smart-img preset="format-32-md" :src="trailerTypeImageUrl(trailer)" class="py-3" width="130" alt=""/>
      </router-link>
    </td>
    <td class="align-middle pl-0 w-auto">
      <small class="grey text-uppercase d-block mb-1">{{ trailerCategoryName(trailer.details.category) }} trailer</small>
      <router-link :to="'/trailers/' + quoteItem.assetId" class="d-block mb-1">
        <span class="text-uppercase">{{ trailer.details.manufacturer }}</span> {{ trailer.details.name }}<small class="grey ml-2">({{ trailer.details.modelYear }})</small>
      </router-link>
      <small v-if="location" class="d-block"><i class="fal fa-map-marker-alt mr-1"></i> {{ location.city }}, {{ location.country }}</small>
      <small v-else class="d-block"><i class="far fa-map-marker-alt mr-1"></i> N/A</small>
    </td>

    <td class="align-middle text-center h5">
      {{ quoteItem.days }}
    </td>
    <td class="align-middle text-center text-nowrap small grey">
      {{ quoteItem.pickupDate | moment('DD/MM-YYYY') }}<br>
      {{ quoteItem.returnDate | moment('DD/MM-YYYY') }}
    </td>
    <td class="align-middle text-right px-3">
      <span style="cursor: pointer" @click="$store.dispatch('quote/removeFromQuote', quoteItem.assetId)"><i class="far fa-times"></i></span>
    </td>
  </tr>
  <tr v-else>
  </tr>
</template>

<script>
    import { mapState } from 'vuex'
    import Number from '@/filters/number.js'

    export default {
        filters: { Number },
        props: ['quoteItem'],
        data: () => ({
            trailer: null,
        }),
        async mounted() {
            this.trailer = await this.$store.dispatch('assets/getAsset', this.quoteItem.assetId)
        },
        computed: {
          ...mapState('user', ['isLoggedIn']),
          ...mapState('locations', ['locations']),
          location: function () {
            return this.locations[this.trailer.depotSlug] ? this.locations[this.trailer.depotSlug] : null
          },
          quoteItemPrice() {
            return 19
          },
          quotePrice() {
            return this.quoteItem.days ? this.quoteItem.days*this.quoteItemPrice : '-'
          },
        },
    }
</script>